/* Ash Theory — Accordion → Drawer
   Intercepts clicks on <summary> elements inside .accordion--drawer-mode
   and opens a stack of right-side drawers instead. */
(function () {
  if (window.__ashAccordionDrawer) return;
  window.__ashAccordionDrawer = true;

  var stack = [];
  var rootEl = null;

  function ensureRoot() {
    if (rootEl) return rootEl;
    rootEl = document.createElement('div');
    rootEl.className = 'ash-acc-drawer-root';
    rootEl.setAttribute('aria-hidden', 'true');

    var backdrop = document.createElement('div');
    backdrop.className = 'ash-acc-drawer-backdrop';
    backdrop.addEventListener('click', closeTop);

    rootEl.appendChild(backdrop);
    document.body.appendChild(rootEl);
    return rootEl;
  }

  function decodeHtmlEntities(str) {
    return String(str || '')
      .replace(/&amp;/gi, '&')
      .replace(/&#0*38;/gi, '&')
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#0*39;/gi, "'")
      .replace(/&apos;/gi, "'");
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function normalizeTitle(str) {
    return decodeHtmlEntities(str).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function stripDuplicateHeading(contentRoot, title) {
    if (!contentRoot || !title) return;
    var want = normalizeTitle(title);
    if (!want) return;
    var candidates = contentRoot.querySelectorAll(
      '.ash-rt__h, h1, h2, h3, h4, .details__header'
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (normalizeTitle(el.textContent) === want) {
        el.remove();
        break;
      }
    }
  }

  function extractTitle(summaryEl) {
    var clone = summaryEl.cloneNode(true);
    clone.querySelectorAll('.svg-wrapper, svg, .icon-caret, .icon-plus').forEach(function (el) {
      el.remove();
    });
    return decodeHtmlEntities((clone.textContent || '').trim());
  }

  function readDrawerSettings(parentAcc) {
    if (!parentAcc) return {};
    var d = parentAcc.dataset || {};
    return {
      side: d.drawerSide || 'right',
      width: parseInt(d.drawerWidth, 10) || 480,
      radius: parseInt(d.drawerRadius, 10) || 0,
      speed: d.drawerSpeed || 'normal',
      chevron: d.drawerChevron || 'caret',
      rowPadding: d.drawerRowPadding || 'normal',
      backdropOpacity: parseInt(d.drawerBackdropOpacity, 10),
      colorScheme: d.drawerColorScheme || '',
      accent: d.drawerAccent || '',
      showBreadcrumb: d.drawerShowBreadcrumb === 'true',
      showDividers: d.drawerShowDivider !== 'false'
    };
  }

  function chevronSVG(kind) {
    if (kind === 'arrow') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
    if (kind === 'plus')  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
    if (kind === 'none')  return '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
  }

  function buildBreadcrumb() {
    if (stack.length === 0) return '';
    var parts = stack.map(function (d) { return d.dataset.title || ''; });
    return parts.join('<span class="ash-acc-drawer__breadcrumb-sep">›</span>');
  }

  function openDrawer(title, contentEl, settings) {
    ensureRoot();
    settings = settings || {};

    var drawer = document.createElement('aside');
    drawer.className = 'ash-acc-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', title || 'Details');
    drawer.dataset.title = title || '';
    drawer.dataset.side = settings.side || 'right';
    drawer.dataset.speed = settings.speed || 'normal';
    drawer.dataset.chevron = settings.chevron || 'caret';
    drawer.dataset.rowPadding = settings.rowPadding || 'normal';
    drawer.dataset.showDividers = settings.showDividers ? 'true' : 'false';
    drawer.style.zIndex = String(1000 + stack.length);

    var styleParts = [];
    if (settings.width) styleParts.push('--ash-drawer-width:' + settings.width + 'px');
    if (settings.radius != null) styleParts.push('--ash-drawer-radius:' + settings.radius + 'px');
    if (!isNaN(settings.backdropOpacity)) styleParts.push('--ash-drawer-backdrop-opacity:' + (settings.backdropOpacity / 100));
    if (settings.accent) styleParts.push('--ash-drawer-accent:' + settings.accent);
    drawer.setAttribute('style', styleParts.join(';'));

    if (settings.colorScheme) {
      drawer.classList.add('color-' + settings.colorScheme);
    }

    var crumbHTML = '';
    if (settings.showBreadcrumb && stack.length > 0) {
      crumbHTML = '<span class="ash-acc-drawer__breadcrumb">' + buildBreadcrumb() + '</span>';
    }

    drawer.innerHTML =
      '<div class="ash-acc-drawer__header">' +
        '<button class="ash-acc-drawer__back" type="button" aria-label="Back"' + (stack.length === 0 ? ' hidden' : '') + '>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>' +
        '</button>' +
        '<div class="ash-acc-drawer__header-text">' +
          crumbHTML +
          '<h2 class="ash-acc-drawer__title">' + escapeHtml(title) + '</h2>' +
        '</div>' +
        '<button class="ash-acc-drawer__close" type="button" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="ash-acc-drawer__content"></div>';

    var contentSlot = drawer.querySelector('.ash-acc-drawer__content');
    if (contentEl) {
      var clone = contentEl.cloneNode(true);
      stripDuplicateHeading(clone, title);
      while (clone.firstChild) {
        contentSlot.appendChild(clone.firstChild);
      }
    }

    drawer.querySelector('.ash-acc-drawer__close').addEventListener('click', closeAll);
    var backBtn = drawer.querySelector('.ash-acc-drawer__back');
    if (backBtn) backBtn.addEventListener('click', closeTop);

    rootEl.appendChild(drawer);
    stack.push(drawer);

    void drawer.offsetWidth;
    drawer.classList.add('is-open');

    document.body.classList.add('ash-acc-drawer-open');
    rootEl.setAttribute('aria-hidden', 'false');
  }

  function closeTop() {
    var top = stack.pop();
    if (!top) return;
    top.classList.remove('is-open');
    setTimeout(function () { if (top.parentNode) top.parentNode.removeChild(top); }, 280);
    if (stack.length === 0) {
      document.body.classList.remove('ash-acc-drawer-open');
      if (rootEl) rootEl.setAttribute('aria-hidden', 'true');
    }
  }

  function closeAll() {
    while (stack.length) {
      var d = stack.pop();
      d.classList.remove('is-open');
      (function (el) { setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 280); })(d);
    }
    document.body.classList.remove('ash-acc-drawer-open');
    if (rootEl) rootEl.setAttribute('aria-hidden', 'true');
  }

  var lastFireTs = 0;

  function handleSummary(e) {
    var summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;
    var parentAcc = summary.closest('.accordion--drawer-mode');
    if (!parentAcc) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    // Debounce so the same user interaction can't fire multiple drawers
    // (e.g. pointerdown followed by click on the same summary).
    var now = Date.now();
    if (now - lastFireTs < 350) return;
    lastFireTs = now;

    var details = summary.closest('details');
    if (!details) return;

    // Force the native <details> shut in case it was already opened
    details.open = false;

    var title = extractTitle(summary);
    var content = details.querySelector(':scope > .details-content')
      || details.querySelector('.details-content');
    var settings = readDrawerSettings(parentAcc);

    openDrawer(title, content, settings);
  }

  // Single capture-phase click listener — beats the native <details> toggle.
  document.addEventListener('click', handleSummary, true);

  // Belt-and-suspenders: if a <details> inside drawer-mode somehow opens, force it shut
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (!(det && det.tagName === 'DETAILS')) return;
    if (!det.closest('.accordion--drawer-mode')) return;
    if (det.open) {
      // Defer to next tick to avoid recursive toggle storm
      setTimeout(function () { det.open = false; }, 0);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && stack.length) {
      e.stopPropagation();
      closeTop();
    }
  });
})();
